import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './video-tw-styles';

class Video extends PureComponent {
  render() {
    const {
      className,
      src,
      allowFullScreen,
      allow,
      frameBorder,
      ...other
    } = this.props;
    return (
      <div className={classNames(styles.videowrapper, className)}>
        <iframe
          title="video"
          src={src}
          style={{
            width: '100%',
            height: '100%',
          }}
          frameBorder={frameBorder}
          allow={allow}
          allowFullScreen={allowFullScreen}
          {...other}
        />
      </div>
    );
  }
}

Video.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Video URL to play in iframe
   */
  src: PropTypes.string,
  allowFullScreen: PropTypes.bool,
  allow: PropTypes.string,
  frameBorder: PropTypes.string,
};

Video.defaultProps = {
  allowFullScreen: true,
  allow: 'autoplay; encrypted-media',
  frameBorder: '0',
  className: '',
  src: '',
};

export default Video;
